export default angular.module("NiabCufApp.irrigation", [
    "KhBase",
    "FiltersData",
    "highcharts-ng",
    "ngTableToCsv"
]);